import styled from 'styled-components';

import React from 'react';

const Div = styled.div`
    color: ${(props) => props.theme.tertiaryFontColor};
    font-family: Poppins;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

const HeadingHome = ({ className, children }) => {
    return <Div className={className}>{children}</Div>;
};

export default HeadingHome;

